import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';

import { pathOr as RpathOr } from 'ramda';

import {
  Card,
  CardActions,
  CardHeader,
  CardMedia,
} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import IconHome from 'material-ui/svg-icons/action/home';
import IconNotificationLiveTv from 'material-ui/svg-icons/notification/live-tv';

import { contextA } from '../../redux/store/configureStore';

const TemplateListContainer = (props) => {
  const { children } = props;
  return (
    <ul className="relative flex flex-wrap p-0 m-0 list-none TemplateListContainer">
      { children }
    </ul>
  );
};
TemplateListContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const TemplateListItem = (props) => {
  const { children } = props;
  return (
    <li className="flex flex-row flex-wrap w-full max-w-lg p-2 sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 TemplateListItem">
      { children }
    </li>
  );
};
TemplateListItem.propTypes = {
  children: PropTypes.node.isRequired,
};

const TemplateCardMedia = (props) => {
  const { children } = props;
  return (
    <CardMedia className="flex items-center content-center h-48 overflow-hidden TemplateCardMedia">
      { children }
    </CardMedia>
  );
};
TemplateCardMedia.propTypes = {
  children: PropTypes.node.isRequired,
};

const Partner = (props) => {
  const { templates, partner } = props;
  return (
    <div>
      <FlatButton
        label="Back"
        containerElement={
          <Link to={{
              pathname: '/',
              }}
          />
          }
        primary
        icon={<IconHome />}
      />
      <TemplateListContainer>
        { Object.keys(templates)
    .map((key) => {
      const template = templates[key];
      return (
        <TemplateListItem key={key} >
          <Card className="flex flex-row justify-around w-full TemplateListItem--Card">
            <CardHeader
              title={template.name}
              avatar={template.photoURL}
            />
            <TemplateCardMedia >
              <img alt="" src={template.photoURL} className="mx-auto" />
            </TemplateCardMedia>
            <CardActions>
              <FlatButton
                label="Show"
                containerElement={
                  <Link to={{
                      pathname: `/${partner.url}/projector/template/byname/${template.name}`,
                      }}
                  />
                  }
                primary
                icon={<IconNotificationLiveTv />}
              />
            </CardActions>
          </Card>
        </TemplateListItem>
      );
    })}
      </TemplateListContainer>

    </div>
  );
};

Partner.propTypes = {
  templates: PropTypes.object,
  partner: PropTypes.object,
};
Partner.defaultProps = {
  templates: {},
  partner: {},
};

const mapStateToProps = (state, props) => {
  const key = RpathOr('NO_KEY1', ['location', 'state', 'partnerKey'], props);
  return ({
    context: state.context,
    command: state.command,
    auth: state.firebase.auth,
    templates: RpathOr({}, ['private', key, 'templates'], state.firebase.data),
    partner: RpathOr({}, ['rootPartners', key], state.firebase.data),
  });
};

const firebaseConfigPartner = (props) => {
  const key = RpathOr('NO_KEY1', ['location', 'state', 'partnerKey'], props);
  return (
    [
      { path: `private/${key}/templates/` },
    ]
  );
};

const ComposedApp = compose(
  firebaseConnect(firebaseConfigPartner),
  connect(mapStateToProps, null, null, {
    context: contextA,
  }),

)(Partner);

const ComponentWithRouter = withRouter(ComposedApp);

export { ComponentWithRouter as Partner };




// WEBPACK FOOTER //
// ./src/components/legacy-partner/index.js